import { render, staticRenderFns } from "./PageHeaderGoodbye.vue?vue&type=template&id=40343fe9&"
import script from "./PageHeaderGoodbye.vue?vue&type=script&lang=js&"
export * from "./PageHeaderGoodbye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports